import { render, staticRenderFns } from "./BrandSales.vue?vue&type=template&id=5cb82730&scoped=true&"
import script from "./BrandSales.vue?vue&type=script&lang=js&"
export * from "./BrandSales.vue?vue&type=script&lang=js&"
import style0 from "./BrandSales.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./BrandSales.vue?vue&type=style&index=1&id=5cb82730&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb82730",
  null
  
)

export default component.exports